<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom: 50px; margin-top: 18px"
  >
    <el-form
      :model="formData"
      ref="formData"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Event Title </label>
                <div class="col-sm-10">
                  <el-form-item prop="eventTitle">
                    <el-input
                      disabled
                      v-model="formData.lstSchoolEventLangDTO[0].eventTitle"
                      :name="'eventTitle'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> School </label>
                <div class="col-sm-10">
                  <el-form-item prop="school">
                    <el-select
                      disabled
                      v-model="formData.schoolCode"
                      clearable
                      name="districtCode"
                    >
                      <el-option
                        v-for="district in schoolCodeList"
                        :label="district.schoolName"
                        :value="district.schoolCode"
                        :key="district.schoolCode"
                        class="ng-binding"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Requested Event Date & Time
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="startEventDate">
                    <el-input
                      disabled
                      v-model="formData.startEventDate"
                      :name="'startEventDate'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  No. of Students Requested
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="noOfStudents">
                    <el-input
                      disabled
                      style="width: 300px"
                      v-model="formData.noOfStudents"
                      :name="'noOfStudents'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Message </label>
                <div class="col-sm-10">
                  <el-form-item prop="message">
                    <el-input
                      disabled
                      type="textarea"
                      :rows="3"
                      v-model="formData.message"
                      :name="'message'"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Contact Person </label>
                <div class="col-sm-10">
                  <el-form-item prop="contactPersonName">
                    <el-input
                      disabled
                      style="width: 300px"
                      v-model="formData.contactPersonName"
                      :name="'contactPersonName'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Phone number </label>
                <div class="col-sm-10">
                  <el-form-item prop="contactPersonTel">
                    <el-input
                      disabled
                      style="width: 300px"
                      v-model="formData.contactPersonTel"
                      :name="'contactPersonTel'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Email address </label>
                <div class="col-sm-10">
                  <el-form-item prop="contactPersonEmail">
                    <el-input
                      disabled
                      style="width: 300px"
                      v-model="formData.contactPersonEmail"
                      :name="'contactPersonEmail'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <el-divider></el-divider>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Status </label>
                <div class="col-sm-10">
                  <el-form-item prop="status">
                    <div class="status-wrap">
                      <el-select
                        style="width: 200px !important"
                        v-model="formData.status"
                        :name="'status'"
                      >
                        <el-option
                          v-for="item in statusMap"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <el-button
                        @click="handleNavToConfirmedEvent"
                        style="width: 200px !important; margin-left: 20px"
                        type="primary"
                        :disabled="formData.status !== 2"
                      >
                        Add Confirmed Event
                      </el-button>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> My Notes </label>
                <div class="col-sm-10">
                  <el-form-item prop="sloNote">
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="formData.sloNote"
                      :name="'sloNote'"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Last update date </label>
                <div class="col-sm-10">
                  <el-form-item prop="lastUpdateTime">
                    <el-input
                      disabled
                      style="width: 300px"
                      v-model="formData.lastUpdateTime"
                      :name="'lastUpdateTime'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <!-- TODO -->
                    <el-button
                      type="primary"
                      v-if="
                        (checkPermission('School_Request_updateStatus') &&
                          $route.query.id) 
                      "
                      @click="checkEvent()"
                    >
                      {{ $t("message.Save") }}
                    </el-button>
                    <el-button @click="showWarning()">
                      {{ $t("message.Cancel") }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      formData: {
        lstSchoolEventLangDTO: [
          {
            eventTitle: "",
          },
        ],
        schoolCode: "",
        startEventDate: "",
        noOfStudents: "",
        message: " ",
        contactPersonName: "",
        contactPersonTel: "",
        contactPersonEmail: "",
        status: 0,
        sloNote: "",
        lastUpdateTime: "2021-10-30 15:30:21",
      },
      schoolCodeList: [],
    };
  },
  computed: {
    statusMap() {
      return [
        { value: 0, label: "Pending" },
        { value: 1, label: "To follow-up" },
        { value: 2, label: "Confirmed" },
        { value: 3, label: "Rejected" },
      ];
    },
    showSchoolName() {
      const resSchool = this.schoolCodeList.find((i) => {
        return i.schoolCode == this.formData.schoolCode;
      });
      return resSchool ? resSchool.schoolName : "";
    },
    userInfo() {
      return this.getAuthObj();
    },
  },
  created() {
    this.getSchoolCodeList();
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      let id = Number(this.$route.query.id);
      if (id) {
        const params = {
          ...this.formData,
          ...this.userInfo,
          id,
          apiUrl: "/schoolEventRequest/getConfirmedEvent",
        };

        let data = await this.$store.dispatch("apiEvent", params);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        this.formData = data.data.result;
      }
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
      }
    },
    checkEvent() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit(isNavToConfirmedEvent) {
      const params = {
        status: this.formData.status,
        sloNote: this.formData.sloNote,
        id: Number(this.$route.query.id),
        ...this.userInfo,
        apiUrl: "/schoolEventRequest/updateStatus",
      };
      var data;
      data = await this.$store.dispatch("apiEvent", params);

      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        if (isNavToConfirmedEvent) return true;
        else this.$router.go(-1);
      }
    },
    async getSchoolCodeList() {
      let obj = this.getAuthObj();
      obj.pageIndex = 1
      obj.pageSize = 99999
      obj.apiUrl = this.apiConfig.schoolCodeList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "schoolCodeList", data.data.result.schools);
    },
    async handleNavToConfirmedEvent() {
      // const submitSuccess = await this.submit('isNavToConfirmedEvent')
      // if(!submitSuccess) return
      const params = {
        ...this.formData,
        schoolCode: this.formData.schoolCode,
      };
      delete params["status"];
      delete params["sloNote"];
      delete params["lastUpdateTime"];
      this.$router.push({
        path: "confirmedEventDetail",
        query: { eventRequestparams: params },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input {
  max-width: 600px;
}
::v-deep .el-textarea {
  max-width: 600px;
}
::v-deep .el-textarea__inner {
  color: #606266 !important;
}
</style>